export default __webpack_public_path__ + "static/media/user_profile.dd4470e0.jpg";